import { Spin } from "antd";
export default function SpinLoader() {
  return (
    <div className="spin-container">
      <Spin />
    </div>
  );
}
